"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("react-dom/client");
const router_1 = __importDefault(require("./router"));
require("./assets");
const MOUNT_POINT = document.getElementById('app');
(0, client_1.hydrateRoot)(MOUNT_POINT, (0, jsx_runtime_1.jsx)(router_1.default, {}));
